import { Card, Stack, Text, textVariants } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { cx } from '@eti/styles';
import CaretButtonWithDrawer from '../common/CaretButtonWithDrawer';
import TitledCard from '../../../../common/components/TitledCard';
import ContactMethods from '../../../../common/components/ContactMethods';
import { bulletStyles, textKeyTitleStyles } from '../../../../utils/styleUtils';
import MedicalCertificate from '../common/MedicalCertificate';

const EditTrip = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const shouldShowMedCert = p('OrderDetails.MedicalCertificate.Enabled');

  return (
    <TitledCard
      data-testid="edit-trip-card"
      headingLevel={2}
      title={t('ManageTrip.EditTrip.Title')}
    >
      <Stack>
        <CaretButtonWithDrawer
          dataTestId="name-correction-button"
          drawerContent={
            <Stack data-testid="name-correction-drawer-content">
              <Card>
                <Text asHtml className={cx(bulletStyles(), textKeyTitleStyles)}>
                  {t('ContactUs.Subtopic.NameCorrection.Content')}
                </Text>
              </Card>
              <Card data-testid="name-correction-contact-methods">
                <ContactMethods chatType="genesys" isCallExpanded />
              </Card>
            </Stack>
          }
          drawerTitle={t('ContactUs.Subtopic.NameCorrection.Title')}
          snowplow={{
            category: 'Manage Trip',
            label: 'MODIFY_NAMES',
          }}
        >
          <Text variant={textVariants._16_BOLD}>
            {t('ContactUs.Subtopic.NameCorrection.Title')}
          </Text>
        </CaretButtonWithDrawer>
        <CaretButtonWithDrawer
          dataTestId="add-passenger-button"
          drawerContent={
            <Stack data-testid="add-passenger-drawer-content">
              <Card>
                <Text asHtml className={cx(bulletStyles(), textKeyTitleStyles)}>
                  {t('ContactUs.Subtopic.AddPassenger.Content')}
                </Text>
              </Card>
              <Card data-testid="add-passenger-contact-methods">
                <ContactMethods chatType="genesys" isCallExpanded />
              </Card>
            </Stack>
          }
          drawerTitle={t('ContactUs.Subtopic.AddPassenger.Title')}
          snowplow={{
            category: 'Manage Trip',
            label: 'ADD_PASSENGERS',
          }}
        >
          <Text variant={textVariants._16_BOLD}>{t('ContactUs.Subtopic.AddPassenger.Title')}</Text>
        </CaretButtonWithDrawer>
        {shouldShowMedCert && (
          <MedicalCertificate
            snowplow={{
              category: 'Manage Trip',
              label: 'MEDICAL_CERTIFICATE',
            }}
          />
        )}
      </Stack>
    </TitledCard>
  );
};

export default EditTrip;
